import { PdpSharedDetail_detailValues } from './__generated__/PdpSharedDetail_detailValues.graphql';

import { FC, lazy, Suspense } from 'react';
import { PdpSharedDetail } from './PdpSharedDetail';

type Props = {
    currency: string;
    delimiter: string;
    detailValues: PdpSharedDetail_detailValues;
    isClient: boolean;
    selectedSkuId: string;
};
export const PdpSharedDetailLabReport: FC<Props> = ({
    currency,
    delimiter,
    detailValues,
    isClient,
    selectedSkuId,
}) => {
    const LabReportTip = lazy(
        () =>
            import(
                /* webpackChunkName: "PdpSharedDetailLabReportTip" */ './PdpSharedDetailLabReportTipLazy'
            )
    );

    return (
        <>
            <PdpSharedDetail
                detailValues={detailValues}
                currency={currency}
                delimiter={delimiter}
                selectedSkuId={selectedSkuId}
            />
            {isClient && (
                <Suspense fallback="">
                    <LabReportTip />
                </Suspense>
            )}
        </>
    );
};
